import {useGTMDispatch} from './react-gtm-hook/index'
import {transformAlgoliaItemsForGA4} from './utils'
import {useRapidDeliveryStore} from '../store/hooks/useStore'

export const useViewItemListTracking = () => {
  const sendDataToGTM = useGTMDispatch()
  const rapidStore = useRapidDeliveryStore()
  const sendViewItemListData = (viewItemListData) => {
    const {items, listType, pageId, region, badges, promo, isPromoModal} = viewItemListData
    setTimeout(() => {
      try {
        const itemListName = listType?.name ?? listType
        const transformAlgoliaData = {
          items,
          hitItemIndex: null,
          trackingData: {itemListName, badges},
          isRapidDeliveryBooked: rapidStore.isRapidDeliveryBooked
        }
        const _items = transformAlgoliaItemsForGA4(transformAlgoliaData)
        let listId
        if (pageId) {
          listId = pageId
        } else {
          listId = listType?.id ?? 'Search Results'
        }
        sendDataToGTM({
          event: 'view_item_list',
          ecommerce: {
            item_list_id: _items.length === 0 ? 'Search No Results Page' : (promo?.id ?? listId),
            item_list_name: isPromoModal ? 'Promotional Modal' : (listType?.name ?? listType),
            region,
            ...(_items.length > 0 ? {items: _items} : {}),
            item_list_total: _items.length,
          }
        })
      } catch (error) {
        console.error('useViewItemListTracking error within setTimeout: ' + error.message)
      }
    }, 0)
  }
  return sendViewItemListData
}